import React, {Component} from 'react';
import { connect } from 'react-redux';
import CardWidget from "../card-widget/CardWidget";
import {RouteConstants} from "../route/services/RouteConstants";
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import CardWidgetTextInput from "../card-widget/CardWidgetTextInput";
import { getLanguage } from "../../store/rootReducer";
import UrlParamsUtil from "../../services/util/UrlParamsUtil";
import ValidationService from '../registration/services/ValidationService';
import {USER_CREATION_STATE} from "../common/UserCreationState";

class ForgotPasswordInitialization extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      errorMessage: null,
      clientId:null

    };
  }

  submitForgotPasswordForm = () => {
    if (!ValidationService.isValidEmail(this.email, true)) {
      this.setState({
        errorMessage: "forgotpassword.enter_email_error"
      });
      return;
    }
    let request = {"email": this.email, "lang": this.props.language, "clientId": this.state.clientId};
    Api.post(ApiPaths.FORGOT_PASSWORD, request).then(

      (response) => {
           if (response.data.userCreationState === USER_CREATION_STATE.IN_PROCESS) {
              this.props.history.push({
                  pathname: RouteConstants.INCOMPLETE_REGISTRATION,
                  state: { email: request.email }
              })
          }else {
              this.props.history.push(RouteConstants.FORGOT_PASSWORD_SENT);
          }

      },
      (error) => {
        this.setState({
          errorMessage: "common.general_processing_error"
        });
    });
  };

  handleEmailChange = (e) => {
    this.email = e.target.value;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitForgotPasswordForm();
  };

  getForgotPasswordContent = () => {
    return (
        <form onSubmit={(e)=> this.handleSubmit(e)}>
          <CardWidgetContent contentText="forgotpassword.initialization_intro"/>
          <CardWidgetErrorsContainer errorMessage={this.state.errorMessage}/>
          <CardWidgetTextInput fieldLabel="forgotpassword.email_field_label" onChange={this.handleEmailChange}/>
        </form>
    )
  };

  render() {
    return (
        <CardWidget getCardContent={this.getForgotPasswordContent}
                    submitButtonAction={() => this.submitForgotPasswordForm()}
                    submitButtonText="forgotpassword.next"
                    cancelButtonAction={() => this.props.history.goBack()}
                    cancelButtonText="forgotpassword.cancel"/>
    )
  };

    componentDidMount() {
        let parsedParams = UrlParamsUtil.getQueryParamsFromUrl(this.props);
        if (parsedParams.clientId) {
            this.setState({
                clientId: parsedParams.clientId
            })
        }
    }

}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

export default connect(mapStateToProps)(ForgotPasswordInitialization);